import * as React from "react"
import { Link } from "gatsby"

// import BlogSideNew from "./blog_sidenew"
// import TopicSide from "./topic_side"
import ProductSide from "./product_side"
import SidebarPopular from "./sidebar_popular"
import { useProductNew } from "../../hooks/use-product-new"

const BlogSidebar = ({category}) => {
  const productNew = useProductNew()
  let sidebanner

  if (category === "eccube") {
    sidebanner = (
      <div className="mt-8">
        <a id="banner_bottom" className="click__sidebanner" href="https://designup.jp/product-bootcube2.html"><img src="https://storage.designup.jp/store/images/bootcube2-img-long.png" alt="bootcube2" className="w-full"/></a>
      </div>
    )
  }

  return (
    <aside>
      <div className="">
        <div className="sidebar__header mb-7">
          <p className="m-0 font-bold text-center tracking-widest">\ 人気記事 /</p>
        </div>
        <SidebarPopular/>
      </div>
      <div className="mt-14">
        <div className="sidebar__header mb-7">
          <p className="m-0 font-bold text-center tracking-widest">\ 人気テンプレート /</p>
        </div>
        <ProductSide posts={productNew} />
        <div className="sidebar__footer mt-7 text-center">
          <Link className="inline-block text-sm font-bold px-5 py-2 border-2 border-black rounded-full hover:bg-black hover:text-white ease-out duration-300" to="/products">テンプレート一覧を見る</Link>
        </div>
      </div>
      <div className="category mt-14">
        <div className="sidebar__header mb-7">
          <p className="m-0 font-bold text-center tracking-widest">\ カテゴリ /</p>
        </div>
        <nav className="category__body">
          <ul className="flex flex-wrap">
            <li><Link className="click__sidecategory inline-block mb-3 mr-3 text-sm font-bold bg-gray-100 px-3 py-2" to="/figma">Figma</Link></li>
            <li><Link className="click__sidecategory inline-block mb-3 mr-3 text-sm font-bold bg-gray-100 px-3 py-2" to="/sozai">素材</Link></li>
            <li><Link className="click__sidecategory inline-block mb-3 mr-3 text-sm font-bold bg-gray-100 px-3 py-2" to="/tools">デザインツール</Link></li>
            <li><Link className="click__sidecategory inline-block mb-3 mr-3 text-sm font-bold bg-gray-100 px-3 py-2" to="/studio">STUDIO</Link></li>
            <li><Link className="click__sidecategory inline-block mb-3 mr-3 text-sm font-bold bg-gray-100 px-3 py-2" to="/elementor">Elementor</Link></li>
            <li><Link className="click__sidecategory inline-block mb-3 mr-3 text-sm font-bold bg-gray-100 px-3 py-2" to="/base">BASE</Link></li>
            <li><Link className="click__sidecategory inline-block mb-3 mr-3 text-sm font-bold bg-gray-100 px-3 py-2" to="/wordpress">Wordpress</Link></li>
            <li><Link className="click__sidecategory inline-block mb-3 mr-3 text-sm font-bold bg-gray-100 px-3 py-2" to="/shopify">Shopify</Link></li>
            <li><Link className="click__sidecategory inline-block mb-3 mr-3 text-sm font-bold bg-gray-100 px-3 py-2" to="/eccube">EC-CUBE</Link></li>
            <li><Link className="click__sidecategory inline-block mb-3 mr-3 text-sm font-bold bg-gray-100 px-3 py-2" to="/coding">コーディング</Link></li>
            <li><Link className="click__sidecategory inline-block mb-3 mr-3 text-sm font-bold bg-gray-100 px-3 py-2" to="/html_css">HTML&CSS</Link></li>
          </ul>
        </nav>
      </div>
      {sidebanner}
    </aside>
  )
}

export default BlogSidebar